export default {
  Title: 'List of Licenses',
  STT: 'No.',
  Country: 'Country',
  Domain: 'Domain',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  Package: 'Package',
  ExpandTime: '{date} days until expiration',
  OverTime: 'Expired {date} days ago',
  Trial: 'Trial',
  Starter: 'Starter',
  Standard: 'Standard',
  Advanced: 'Advanced',
  Upgrade: 'Upgrade',
  Extend: 'Extend',
  PurchaseDevice: 'Purchase devices',
  UpdateInfo: 'Update information',
  LicenseInfo: 'License Info',
  Filter: 'Filter',
  All: 'All',
  FromDate: 'From date',
  ToDate: 'To date',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Total: 'Total: {number} requests',
  TotalLicenses: 'Total: {number} licenses',
  TotalLicensesRange: 'domains',
  TotalSubtotal: 'Total',
  Save: 'Save',
  Search: 'Search',
  PendingRequest:'There is a pending request already on the license. Please check again.',
  Infor: 'Information',
  NewestInvoiceDate: 'Newest invoice date',
  DayAgo: '{date} days ago',
  Today: 'Today',
  AllFilter: 'All',
  In30Days: 'Within 30 days',
  Out30Days: 'Older than 30 days',
  Partner: 'Partner',
  Status: 'Status',
  Inactive: 'Inactive',
  Active: 'Active',
  NumOfBranch: 'Number of branches',
  PartnerCountryTooltip: 'Your Partner operates in only one country. Selecting other countries may not return any results.',
  WrongCountrySelected: 'No license data for this country. Your Partner operates in only one specific country.',
  ResetToPartnerCountry: 'Reset to Partner country',
  NoLicenseData: 'No matching data found',
  PartnerRoleTooltip: 'As a Partner, you cannot change the assigned Partner.',
  ResetToDefaultRate: 'Reset to default exchange rate',
  ExchangeRateDefault: 'Default exchange rate: {rate}'
};
